import createVueComponent from '../createVueComponent';
var X = createVueComponent('XIcon', [['line', {
  x1: '18',
  y1: '6',
  x2: '6',
  y2: '18',
  key: '1o5bob'
}], ['line', {
  x1: '6',
  y1: '6',
  x2: '18',
  y2: '18',
  key: 'z4dcbv'
}]]);
export default X;